import styled from "styled-components";


export const SubCategorysContainer = styled.div`
display: flex;
flex-direction: column;
width: 100vh;
height: auto;
`